module.exports = __webpack_public_path__ + "static/img/m1.3423143.png";


//////////////////
// WEBPACK FOOTER
// ./static/m1.png
// module id = PNtZ
// module chunks = 1